import axios from 'axios';
import config from '../components/Config/key';
import { redirectToLogin } from './sessionGuard';

/**
 * Axios インスタンスの設定
 * 全てのAPIリクエストにAPI キーヘッダーを自動的に追加
 */

// デフォルトのaxiosインスタンスにインターセプターを追加
axios.interceptors.request.use(
  (requestConfig) => {
    // JWT を Authorization ヘッダーに自動付与（操作ログ: サーバー側 resolveActor が実行者を識別する）
    // 既存の個別方式（body executorToken / x-user-token / URL パラメータ）とは併存し、後方互換を保つ
    try {
      const authToken = localStorage.getItem('w_auth');
      if (authToken && !requestConfig.headers['Authorization']) {
        requestConfig.headers['Authorization'] = 'Bearer ' + authToken;
      }
    } catch (e) {}

    // API キーをヘッダーに追加
    if (config.API_KEY) {
      requestConfig.headers['X-API-Key'] = config.API_KEY;

      // // フォールバック: クエリパラメータにも追加（Firewall対策）
      // if (!requestConfig.params) {
      //   requestConfig.params = {};
      // }
      // requestConfig.params.apiKey = config.API_KEY;
    } else {
      console.warn(
        '[WARNING] APIキーが設定されていません。環境変数REACT_APP_API_KEYを確認してください。'
      );
    }

    // 活動ベースのスライディング更新（10 分スロットル）。renew/auth/logout は除外（再帰防止）
    try {
      const url = requestConfig.url || '';
      const isMeta =
        url.includes('/users/renew/') ||
        url.includes('/users/auth/') ||
        url.includes('/users/logout/');
      if (!isMeta) {
        const tok = localStorage.getItem('w_auth');
        const exp = localStorage.getItem('w_authExp');
        // 有効なセッションのときだけ延長（失効は延長しない）
        if (tok && exp && Date.now() <= Number(exp)) {
          const last = Number(localStorage.getItem('w_authRenewAt') || 0);
          const THROTTLE = 10 * 60 * 1000;
          if (Date.now() - last > THROTTLE) {
            // 先に記録して二重発火を防ぐ
            localStorage.setItem('w_authRenewAt', String(Date.now()));
            axios
              .get('/api/users/renew/' + tok)
              .then((r) => {
                if (r && r.data && r.data.success && r.data.w_authExp) {
                  localStorage.setItem('w_authExp', String(r.data.w_authExp));
                }
              })
              .catch(() => {
                // 更新失敗は静かに無視（次の活動で再試行。失効は定期チェックが検知）
              });
          }
        }
      }
    } catch (e) {}

    return requestConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// レスポンスインターセプター（エラーハンドリング用）
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        const url = error.config?.url || '';
        // 認証チェックAPI（/users/auth/:token）からの401は通常の未ログイン判定なので除外
        // それ以外のAPI呼び出しでの401はセッション切れと判定し、自動ログアウト
        const isAuthCheckCall = url.includes('/users/auth/');

        if (!isAuthCheckCall) {
          console.warn('セッション切れを検知 → 自動ログアウト');
          // clear + alert + returnTo は redirectToLogin が担当（現在のウィンドウでログインへ）
          redirectToLogin({ withAlert: true });
        }
      } else if (error.response.status === 403) {
        console.error('APIキー認証エラー: 無効なAPIキーです');
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
